import { Flex, Skeleton } from 'antd';
import { ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { COLOR } from '@styles/theme';
import { INBOUND_SHIPMENTS_LIST } from '@utility/utils/shipment-display';
import {
  MainDetailPanel,
  SecondaryHeaderBar,
  SidebarDetailPanel,
  StepsCenter,
} from './inboundDetailStyled';

export function InboundShipmentSecondaryHeaderSkeleton() {
  return (
    <SecondaryHeaderBar>
      <Link
        to={INBOUND_SHIPMENTS_LIST}
        style={{ position: 'relative', zIndex: 1, flexShrink: 0, textDecoration: 'none' }}
      >
        <Flex align="center" gap={6}>
          <ArrowLeft size={16} color={COLOR.black} />
          <Skeleton.Input active size="small" style={{ width: 128, minWidth: 100 }} />
        </Flex>
      </Link>

      <StepsCenter>
        <Skeleton.Node active style={{ width: 520, height: 28 }} />
      </StepsCenter>
    </SecondaryHeaderBar>
  );
}

export function InboundShipmentDetailSkeleton() {
  return (
    <Flex gap={16} align="flex-start" wrap="wrap">
      <MainDetailPanel>
        <Flex style={{ minHeight: 420 }}>
          <Flex
            vertical
            gap={12}
            style={{
              width: 120,
              flexShrink: 0,
              padding: '16px 12px',
              borderRight: `1px solid ${COLOR.border}`,
            }}
          >
            <Skeleton.Input active size="small" block />
            <Skeleton.Input active size="small" block />
          </Flex>
          <Flex flex={1} justify="center" align="center" style={{ padding: 48 }}>
            <Skeleton
              active
              avatar={{ shape: 'square', size: 48 }}
              paragraph={{ rows: 2, width: ['80%', '60%'] }}
              title={false}
              style={{ maxWidth: 360 }}
            />
          </Flex>
        </Flex>
      </MainDetailPanel>

      <SidebarDetailPanel>
        <Flex vertical gap={16}>
          <Flex gap={16}>
            <Skeleton.Button active size="small" style={{ width: 48 }} />
            <Skeleton.Button active size="small" style={{ width: 72 }} />
            <Skeleton.Button active size="small" style={{ width: 88 }} />
            <Skeleton.Button active size="small" style={{ width: 80 }} />
          </Flex>
          <Skeleton active paragraph={{ rows: 6 }} title={false} />
        </Flex>
      </SidebarDetailPanel>
    </Flex>
  );
}
